import { render, staticRenderFns } from "./LockdownPopup.vue?vue&type=template&id=f43f0932&scoped=true"
import script from "./LockdownPopup.vue?vue&type=script&lang=js"
export * from "./LockdownPopup.vue?vue&type=script&lang=js"
import style0 from "./LockdownPopup.vue?vue&type=style&index=0&id=f43f0932&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f43f0932",
  null
  
)

export default component.exports